import { render, staticRenderFns } from "./GamesList.vue.vue?vue&type=template&id=20246357&scoped=true&"
import script from "./GamesList.vue.vue?vue&type=script&lang=js&"
export * from "./GamesList.vue.vue?vue&type=script&lang=js&"
import style0 from "./GamesList.vue.vue?vue&type=style&index=0&id=20246357&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20246357",
  null
  
)

export default component.exports